import binaryGetFetcher from 'api/utils/binaryGetFetcher';
import { useCallback } from 'react';

interface UseDownloadInvoiceProps {
  orgId?: OrgId;
}

const useDownloadInvoiceCall = ({ orgId }: UseDownloadInvoiceProps) => {
  const callback = useCallback(
    async (invoiceId?: InvoiceId) => {
      if (!orgId) {
        return undefined;
      }
      const queryParams = new URLSearchParams({ orgId: `${orgId}` });
      const url = `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/invoices/${invoiceId}/download?${queryParams}`;
      const result: Blob | undefined = await binaryGetFetcher(url);

      return result;
    },
    [orgId]
  );

  return callback;
};

export default useDownloadInvoiceCall;
